export default __webpack_public_path__ + "static/media/77.0861c46d.jpeg";